// extracted by mini-css-extract-plugin
module.exports = {"layout":"style_layout__1FplQ","grid_item":"style_grid_item__WMCQx","item__icon":"style_item__icon__2Qu1V","item__title":"style_item__title__34hXc"};